export default from './post-title';



// WEBPACK FOOTER //
// ./app/components/post-title/index.js